import React, { useEffect, useState } from 'react'
import { useLocalStream } from '../hooks/localStream'
import { useFaceDetection } from '../hooks/faceDetection'
import { publishX } from '../beebotte/publish'
import Peer from 'skyway-js'
import { useHistory } from 'react-router-dom'

const Conversation: React.FC = () => {
  const videoRef = React.createRef<HTMLVideoElement>()
  const { localStream } = useLocalStream(videoRef)
  const { modelLoaded, startDetection, x } = useFaceDetection(videoRef)
  const [connected] = useState(false)
  const [peer, setPeer] = useState<Peer | null>(null)
  const peerId = 'phat-thai-detect'
  const history = useHistory()

  useEffect(() => {
    if (peer) return
    const newPeer = new Peer(peerId, {
      key: '792214eb-3855-4d7f-8788-539a222041cf',
      debug: 2
    })
    newPeer.on('error', (e: any) => {
      console.log('peer error:', e.type)
      history.push('/')
      alert('他の人が使用中です')
    })
    newPeer.once('open', (id) => {
      console.log(id)
      setPeer(newPeer)
    })
  }, [history, peer, peerId])

  // localStreamが用意できたら顔認識を開始
  useEffect(() => {
    if (!localStream || !modelLoaded || !peer) return
    startDetection()
  }, [connected, localStream, modelLoaded, peer, startDetection])

  // xの値が更新されたらbeebotteにpublish
  useEffect(() => {
    publishX(x)
  }, [x])

  return (
    <div style={{ width: '100vw', height: '100vw', position: 'relative' }}>
      <video
        ref={videoRef}
        autoPlay
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          objectFit: 'contain',
          width: '100%',
          maxHeight: '100%',
          transform: 'rotateY(180deg)'
        }}
      />
      {!localStream ? (
        <div
          style={{
            position: 'fixed',
            height: '100vh',
            width: '100vw',
            top: 0,
            left: 0,
            textAlign: 'center'
          }}
        >
          loading...
        </div>
      ) : null}
    </div>
  )
}

export default Conversation
